import type { CSSProperties, ReactNode } from "react";
import { cn } from "@repo/utils";

export const containerGutter = "px-4 sm:px-6 lg:px-8";

interface PageContainerProps {
  children: ReactNode;
  noPaddingY?: boolean;
  className?: string;
  style?: CSSProperties;
}

export function PageContainer({
  children,
  noPaddingY = false,
  className,
  style,
}: PageContainerProps) {
  return (
    <div
      style={style}
      className={cn(
        "mx-auto w-full min-w-0 max-w-[1600px]",
        containerGutter,
        !noPaddingY && "py-8",
        className,
      )}
    >
      {children}
    </div>
  );
}
